<template>
  <v-card>
    <v-card-title>Edit Your Shipping Location</v-card-title>
    <v-card-text>
      <form @submit.prevent="SubmitShipping">
        <v-text-field
          name="shippingname"
          label="Shipping Address name"
          id="shippingname"
          hint="Name to remember this Shipping Location by, ie. Home, or Mom's House or something like that"
          required
          v-model="shippinglocation.name"
        ></v-text-field>
        <v-textarea
          name="shippingaddress"
          label="Shipping Address"
          id="shippingaddress"
          hint="Complete Shipping address, as it would appear on a package or envelope, where applicable."
          required
          v-model="shippinglocation.address"
        ></v-textarea>
        <v-textarea
          name="shippinginformation"
          label="Extra Information"
          id="shippinginformation"
          v-model="shippinglocation.information"
          hint="Any extra information about this location you wanna save, not publicly visible."
        ></v-textarea>
        <v-checkbox
          color="green"
          v-model="checkbox"
          hint="Would you like to set this as your default shipping address?"
          persistent-hint>
          <div slot="label">
            Set to default
          </div>
        </v-checkbox>
        <v-col cols="4" offset="5">
          <v-btn type="submit" :loading="shippinginfosubmitloading" :disabled="shippinginfosubmitloading" color="primary">
            Submit
            <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
          </v-btn>
        </v-col>
      </form>
    </v-card-text>
  </v-card>

</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, maxLength } from 'vuelidate/lib/validators';


export default {
  mixins: [validationMixin],
  data: () => ({
    shippingname: '',
    shippingaddress: '',
    shippinginformation: '',
    checkbox: false,
    shippinginfosubmitloading: false,
    shippinglocation: [],


  }),
  props: {
    original_shipping_location: Object,
  },
  computed: {
  },
  methods: {
    GetShippingLocationInfo() {
      const shiplocid = this.original_shipping_location.id;
      this.shippinglocation = [];
      return axios.get(`shippinglocations/${shiplocid}/`)
        .then((response) => {
          this.shippinglocation = response.data;
        });
    },
    SubmitShipping() {
      const shiplocid = this.original_shipping_location.id;
      this.shippinginfosubmitloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.patch(`shippinglocations/${shiplocid}/`, {
        name: this.shippinglocation.name,
        address: this.shippinglocation.address,
        information: this.shippinglocation.information,
      },
      {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          if (this.checkbox) {
            return axios.patch('profile/saveddefaults/', {
              default_shipping_location: shiplocid,
            },
            {
              headers: {
                Authorization: authheader,
              },
            });
          }
        })
        .then(() => {
          this.shippinginfosubmitloading = false;
          this.$emit('close-editshiploc');
        })
        .catch((error) => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong when trying to submit this location. We\'ll fix it, sorry for the hassle.', alert_model: true,
          });
        });
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
  },
  mounted() {
    this.GetShippingLocationInfo();
  },
};
</script>

<style scoped>

</style>
